import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '../custom-date-parser-formatter'
import { CommonsService } from '../commons-service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { RepositoryService } from '../repository.service';
import { CustomerModel } from '../models/customer-model';
import { ContactTypeModel } from '../models/contact-type-model';
import { CustomerContactModel } from '../models/customer-contact-model';
declare const log: any
declare const dataModels: any
declare const $: any

@Component({
  selector: 'app-add-customer-contact',
  templateUrl: './add-customer-contact.component.html',
  styleUrls: ['./add-customer-contact.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class AddCustomerContactComponent implements OnInit {

  textTitle = ""
  uuidCustomer = ""
  customer: CustomerModel | null = new CustomerModel()
  customerContact: CustomerContactModel = new CustomerContactModel()
  contactTypes: ContactTypeModel[] = []
  textDate = CommonsService.formatDate0(new Date())
  textDateNextContact = ""
  showNewTaskButton: boolean = true

  constructor(
    protected location: Location,
    protected route: ActivatedRoute,
    protected router: Router,
    protected translate: TranslateService,
    protected repository: RepositoryService,
  ) { }

  ngOnInit(): void {
    this.init0()
  }

  async init0() {
    this.contactTypes = <ContactTypeModel[]>await this.repository.contactTypes.readAll()
    await this.initSpecific()
  }

  async initSpecific() {
    this.translate.get("CONTACT_ADD_TITLE").subscribe((translated) => this.textTitle = translated)

    const routeParams = this.route.snapshot.paramMap;
    this.uuidCustomer = String(routeParams.get('uuidCustomer'));

    this.customerContact.uuid = UUID.UUID()
    this.customerContact.uuidContactType = this.contactTypes[0].uuid
    this.customerContact.uuidCustomer = this.uuidCustomer

    this.textDateNextContact = ""

    await this.init()
  }

  async init() {

    $('#div-date').datetimepicker({
      format: 'DD.MM.YYYY HH:mm'
    });

    $('#div-next-contact').datetimepicker({
      format: 'DD.MM.YYYY HH:mm'
    });

    this.customer = await this.repository.customers.read(this.customerContact.uuidCustomer, true)
    if( this.customer == null ) {
      CommonsService.showErrorMessage(this.translate.instant("ERROR_INVALID_VALUE"))
      this.location.back()
    }

    this.textDate = CommonsService.formatDateTime0(this.customerContact.date)
  }

  async save(navigate: boolean = true): Promise<boolean> {
    this.customerContact.date = CommonsService.parseDateTime($("#input-date").val())

    let textDateNextContact = $("#input-next-contact").val();
    if (textDateNextContact == "")
      this.customerContact.callbackDate = CommonsService.parseDate("01.01.1900")
    else {
      try {
        this.customerContact.callbackDate = CommonsService.parseDateTime(textDateNextContact)
      } catch (err) {
        CommonsService.showErrorMessage(this.translate.instant("CONTACT_ADD_CALLBACK_DATE_INVALID"))
        return false
      }
    }

    await this.saveSpecific(navigate)
    return true
  }

  async saveSpecific(navigate: boolean = true) {
    await this.repository.createCustomerContact(this.customerContact)
    CommonsService.showSuccessMessage(this.translate.instant("GENERAL_SAVED"))

    // this.location.back()
    if (navigate)
      this.router.navigateByUrl("/editCustomerContact/" + this.customerContact.uuid)
  }

  async addTask() {
    if (!await this.save(false))
      return
    window.history.replaceState({}, '', "/editCustomerContact/" + this.customerContact.uuid);
    this.router.navigateByUrl("/addTask/" + this.customerContact.uuidCustomer)
  }
}
